import React from "react";
import ButtonPrimary from "shared/ButtonPrimary";

import styles from "./ForgotPassword.module.scss";
import { Link } from "react-router-dom";

const ForgotPasswordSent = () => {
  return (
    <div>
      <h2 className={styles.title}>Another day, another password.</h2>
      <p className={styles.description}>
        A reset password link has been sent to your email address. Make sure to
        check it's not in your spam folder.
      </p>
      <div className={styles.buttonContainer}>
        <ButtonPrimary className={styles.button} to="/">
          Log in
        </ButtonPrimary>

        <div className={styles.tryAgainContainer}>
          <p className={styles.tryAgain}>
            Can't find the email?
            <br />
            <Link className={styles.underline} to="/auth/forgot-password">
              Try resetting again
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordSent;
